import { apiService } from "../../services/apiService";
import { utilService } from "../../services/utilService";
import { apiServiceConstants } from "../../constants";

import {
  ResetParams,
  RespResetLinkValid,
  RespResetPassword,
  ResetLinkValidResult,
  ResetPasswordResult
} from "./ResetPassword.model";



const resetPassword = async (params: ResetParams): Promise<ResetPasswordResult> => {
  const respApiResult = await apiService
    .apiCall(
      `auth/reset-password/${params.guid}/?reg_code=${params.reg_code}`,
      params,
      apiServiceConstants.PUT,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as RespResetPassword;
      const result: ResetPasswordResult = {
        isSuccess     : response.isSuccess,
        status        : response.status,
        message       : response.message,
      };
      return result;
    })
    .catch((err) => {
      const result: ResetPasswordResult = {
        isSuccess  : false,
        message    : err.message,
        status     : err.status,
      };
      return result;
    });

  return respApiResult;
};

const getUserId = async (params: any): Promise<ResetLinkValidResult> => {
  const respApiResult = await apiService
    .apiCall(
      "auth/reset-password/?reg_code=" + params.reg_code,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as RespResetLinkValid;
      const result: ResetLinkValidResult = {
        isSuccess     : response.isSuccess,
        status        : response.status,
        message       : response.message,
        userGuid      : response.result?.[0]?.id,
      };
      return result;
    })
    .catch((err) => {
      const result: ResetLinkValidResult = {
        isSuccess  : false,
        message    : err.message,
        status     : err.status,
      };
      return result;
    });

  return respApiResult;
};



export const resetPasswordService = {
  getUserId,
  resetPassword,
}